import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { $Elements, Animations, Events, Classes, Elements } from '../global/constants';


// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Parallax Section ----------

	$('.parallax-section:not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	})

	$('.double-text-image-section, .page-link-section').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .image-column');
			const spaceBottomSection = 160;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(image, {
					y: () => -spaceBottomSection
				}, {
					y: () => (this.clientHeight - image.clientHeight) - spaceBottomSection * 2
				});
			}
		});
	});

	$('.arch-shaped-image-section').each(function() {

		Animations.global.push(() => {

			const line1 = this.querySelector(':scope .line-1');
			const line2 = this.querySelector(':scope .line-2');
			const speed = 20;

			if(line1) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(line1, { xPercent: 20 }, { xPercent: -speed * 2, ease: 'none' });
			}

			if(line2) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(line2, { xPercent: 60 }, { xPercent: -speed * 3, ease: 'none' });
			}
		});
	});

	$('.ajax-posts-section').each(function() {

		Animations.mobile.min.push(() => {

			const self = $(this);
			const images = self.find('.image-column:nth-child(3n - 1)');

			if(images) {

				images.each(function() {
					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: self,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
							invalidateOnRefresh: true,
						},
					});

					timeline.fromTo(this, {
						y: () => 0
					}, {
						y: () => -this.clientHeight / 3
					});
				})

			}
		});
	});

	// ---------- Home Sections ----------

	// Horizontal scroll
	$('.home .content-wrapper').each(function() {

		Animations.mobile.min.push(() => {

			const content = this;

			const sections = gsap.utils.toArray('.content-section', content);
			const contentWidth = () => sections.reduce((val, section) => val + section.offsetWidth, 0);
			let maxWidth = 0;

			const refreshValues = () => {
				maxWidth = contentWidth();
			}

			refreshValues();
			ScrollTrigger.addEventListener("refreshInit", refreshValues);

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					pin: true,
					scrub: true,
					invalidateOnRefresh: true,
					start: () => 'top top',
					end: () => "+=" + maxWidth,
				},
			});

			timeline.to(content, {
				x: () => window.innerWidth - (maxWidth + 270),
				ease: "none"
			});

			gsap.timeline({
				scrollTrigger: {
					scrub: true,
					invalidateOnRefresh: true,
					start: -1,
					end: () => "+=" + (window.innerWidth + 270),
					toggleClass: {
						targets: $('.home-introduction'),
						className: Classes.active
					}
				},
			});
		});
	});


	// Transitions between background-colors
	$('.home .content-section').each(function(index) {

		Animations.mobile.min.push(() => {

			const section = this;
			const colors = [];

			$('.home .content-section').each(function() {
				colors.push($(this).data('color'));
			})

			const triggerColorTransition = i => {
				$(this).addClass('revealed');
				colors[i] && gsap.to($('.content-section, body'), { backgroundColor: colors[i], duration: 1.5 });
			};

			const sections = gsap.utils.toArray('.content-section');
			const previousSections = sections.splice(0, index);
			const contentWidth = previousSections.reduce((val, section) => val + section.offsetWidth, 0);

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: section.parentElement,
					start: (self) => (contentWidth),
					id: "section-" + index,
					scrub: true,
					onEnter: () => triggerColorTransition(index),
					onLeaveBack: () => triggerColorTransition(index - 1),
				},
			});
		});
	});


	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Header ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: -1,
					end: 10,
					toggleClass: {
						targets: document.body,
						className: 'on-top'
					},
				}
			});
		});

		if(!$Elements.body.hasClass('home')) {

			Animations.mobile.min.push(() => {

				gsap.timeline({
					scrollTrigger: {
						start: 0,
						end: 'max',
						onUpdate: (self) => {
							self.direction === 1 ? this.classList.add('shrink') : this.classList.remove('shrink');
						}
					}
				});

				gsap.timeline({
					scrollTrigger: {
						start: () => $('.content-section:first-child').height(),
						onEnter: () => $Elements.body.addClass('menu-light'),
						onLeaveBack: () => $Elements.body.removeClass('menu-light')
					}
				});

				gsap.timeline({
					scrollTrigger: {
						start: 0,
						end: () => $('.content-section:first-child').height() + ($(this).height() * 2),
						toggleClass: {
							targets: this,
							className: 'force-shrink'
						}
					}
				});
			});

			Animations.mobile.max.push(() => {

				gsap.timeline({
					scrollTrigger: {
						start: 1,
						onEnter: () => $Elements.body.addClass('menu-light'),
						onLeaveBack: () => $Elements.body.removeClass('menu-light')
					}
				});
			});
		}
	});

};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
